import { EProductsInsurance } from '@if/core/types'
import { formatCurrency } from '@if/core/utils'
import { Typography } from '@mui/material'
import { ProductsInsurancePlan } from '@src/data/types/ProductsWorksheetSchema'
import { useTranslation } from 'react-i18next'

interface Props {
  insurance: ProductsInsurancePlan
}

const ProductInsurance = ({ insurance }: Props) => {
  const { t } = useTranslation()
  const getInsuranceTitle = (type: EProductsInsurance) => {
    return t(`enum.eProductsInsurance.${type}`)
  }
  return (
    <span>
      <Typography variant="body1" component="div" gutterBottom>
        <strong>{getInsuranceTitle(insurance.type)}</strong>
      </Typography>
      <Typography variant="body2" component="div" gutterBottom>
        {t('worksheet.provider')} : {insurance.providerName}
      </Typography>
      <Typography variant="body2" component="div" gutterBottom>
         {t('worksheet.policy')} : {insurance.police}
      </Typography>
      <Typography variant="body2" component="div" gutterBottom>
          {t('worksheet.term')} : {insurance.term} {t('worksheet.month')}
      </Typography>
      {insurance.endDate && (
        <Typography variant="body2" component="div" gutterBottom>
          {t('worksheet.contractEndDate')} : {insurance.endDate} 
        </Typography>
      )}
      <Typography variant="body2" component="div" gutterBottom>
        {t('worksheet.premium')} : {formatCurrency(insurance.amount)}
      </Typography>

    </span>
  )
}

export default ProductInsurance